const Policy = () => {
  return (
    <div>
      <div className="bg-[#efefef] flex justify-center items-center h-[150px]">
        <h1 className="sm:text-[40px] text-[30px] font-bold">Privacy Policy</h1>
      </div>
      <div className="flex flex-col gap-8 max-w-[50rem] mx-auto text-left p-[3rem]">
        <p>
          TCS acknowledges the significance of customer’s right with regard to their data privacy and is entirely devoted 
          to protect their customers’ privacy. TCS Privacy Policy applies to all the data collected from customers to 
          provide them satisfactory services. Our core motive to develop this policy is to make our customer feel 
          self-assured and safe regarding their personal information shared in process of services and responding 
          to their enquires or complaints. We make sure that our employees are well aware of TCS’s policies and regulations.
        </p>
        <div className="text-left">
          <h1 className="font-bold text-left sm:text-[25px] text-[20px]">1. SECURITY</h1>
          <p>
            For TCS the trust of its valuable customer is important, thus we are aiming to use commercially acceptable 
            means to protect the personal information/data of our customers. However, we expect our customers to 
            understand that no method of transmission over the internet, or method of electronic storage is fully 
            secure and reliable thus we cannot guarantee its absolute security and accept no responsibility for any 
            leak of such information.
          </p>
        </div>
        <div className="text-left">
          <h1 className="font-bold text-left sm:text-[25px] text-[20px]">2. PERSONAL DATA</h1>
          <p>
            TCS may require certain personal information including but not limited to Name, Email, phone, GPS location. 
            Any/all information in record shared by customer will remain with TCS as per Privacy Policy.
          </p>
          <p>
            In order to provide services, TCS may engage third-party companies to perform/facilitate/provide/assist 
            in course of our services. These third-party companies will be performing task assign to them on behalf 
            of TCS, hence they will have access to personal information of the customer. However, they are obligated 
            to keep such information confidential and not to use such information except for the purpose of exercising 
            or performing its rights and obligations as specified by TCS.
          </p>
        </div>
        <div className="text-left">
          <h1 className="font-bold sm:text-[25px] text-[20px]">3. COOKIES</h1>
          <p>
            Customer’s cookies and IP addresses are used by TCS to enhance their visit to the website. Website cookies, 
            also known as HTTP cookies, are a necessary function for the modern Internet. As a fundamental part of website 
            browsing, website cookies help organizations deliver a personalized and convenient experience to their customers. 
            If a customer does not disable their cookies, it shall be construed as them permitting TCS to use their cookies. 
            TCS does not guarantee proper functioning of its website unless the customer has their cookies enabled.
          </p>
        </div>
        <div className="text-left">
          <h4 className="font-bold text-left sm:text-[25px] text-[20px]">4. CHANGES TO THIS PRIVACY POLICY</h4>
          <p>
            TCS reserves the right to update its Privacy Policy from time to time without providing any notice to 
            the customer. Thus, the customers are advised to review this page periodically for any changes. 
            These changes are effective immediately after they are posted on this page.
          </p>
        </div>

      </div>
    </div>
  );
};

export default Policy;
